import React, { useEffect, useState } from "react";
import SEO from "../../config/SEO";
import toasted from "../../config/toasted";
import AdultWarningModal from "../../componets/AdultWarningModal";

export default function HotPrompts() {
     const itzpromptUrl = "https://opensheet.elk.sh/1jkN8NHNvYJCLjPOfMb8y1vaDFrxPn_qgHeX5x0k-jMI/none";
     const [prompts, setPrompts] = useState([]);
     const [loading, setLoading] = useState(true);

     // --- PAGINATION STATES ---
     const [currentPage, setCurrentPage] = useState(1);
     const itemsPerPage = 9;

     useEffect(() => {
          const fetchPrompts = async () => {
               try {
                    const res = await fetch(itzpromptUrl);
                    const data = await res.json();
                    setPrompts(data?.reverse() || []);
               } catch (err) { console.error(err); }
               setLoading(false);
          };
          fetchPrompts();
     }, []);

     const copyText = (txt) => {
          navigator.clipboard.writeText(txt);
          toasted.success("Copied 😏");
     };

     // --- PAGINATION LOGIC ---
     const indexOfLastItem = currentPage * itemsPerPage;
     const indexOfFirstItem = indexOfLastItem - itemsPerPage;
     const currentItems = prompts.slice(indexOfFirstItem, indexOfLastItem);
     const totalPages = Math.ceil(prompts.length / itemsPerPage);

     const getPageNumbers = () => {
          const pages = [];
          if (totalPages <= 7) {
               for (let i = 1; i <= totalPages; i++) pages.push(i);
          } else {
               if (currentPage <= 4) {
                    pages.push(1, 2, 3, 4, 5, "...", totalPages);
               } else if (currentPage > totalPages - 4) {
                    pages.push(1, "...", totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
               } else {
                    pages.push(1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages);
               }
          }
          return pages;
     };

     return (
          <>

               <SEO
                    title="Spicy AI Prompt Library (18+) – Bold Creative AI Image Prompts"
                    description="Explore the spicy AI prompt library on HeyPrompt featuring bold and creative prompts for AI image generation and artistic concepts."
                    keywords="spicy ai prompts, 18+ ai prompts, bold ai prompts, creative ai image prompts, artistic ai prompts, ai image prompt ideas"
                    canonicalPath="/18+"
               />

               <div className="premium-layout">

                    <div className="grain-overlay"></div>
                    <div className="radial-glow"></div>

                    <div className="content-wrapper">
                         <section className="hero-banner">
                              <div className="banner-badge">VERSION 3.0 LIVE</div>
                              <h1>The World's Most <span>Spicy</span> Prompt Library.</h1>
                              <p>Unfiltered, raw, and ready to ignite your imagination.</p>

                              <div className="stats-strip">
                                   <div className="stat-item"><span>{prompts.length}+</span> Prompts</div>
                                   <div className="stat-divider"></div>
                                   <div className="stat-item"><span>18+</span> Adult Only</div>
                                   <div className="stat-divider"></div>
                                   <div className="stat-item"><span>∞</span> Updates</div>
                              </div>
                         </section>

                         <main className="prompt-section">
                              <div className="section-header">
                                   <h2>Trending <span>Archive</span></h2>
                                   <div className="live-indicator"><span className="dot"></span> LIVE FEED</div>
                              </div>

                              <div className="custom-grid">
                                   {loading ? (
                                        [...Array(6)].map((_, i) => <div className="skeleton-card" key={i}></div>)
                                   ) : (
                                        currentItems.map((p, i) => (
                                             <div className="spice-card" key={i}>
                                                  <div className="card-top">
                                                       <span className="rank">#{prompts.length - (indexOfFirstItem + i)}</span>
                                                       <button className="copy-btn" onClick={() => copyText(p.prompt || p.text)}>COPY</button>
                                                  </div>

                                                  <div className="card-middle">
                                                       <p>
                                                            {(p.prompt || p.text)
                                                                 .slice(0, 300)
                                                                 .replace(/(\s\S+\s\S+\s)/g, "$1 ⋆˙⟡⋆˙⟡ ")}
                                                       </p>
                                                  </div>

                                                  <div className="card-bottom">
                                                       <span className="timestamp">{p.date || "New Arrival"}</span>
                                                  </div>
                                             </div>
                                        ))
                                   )}
                              </div>

                              {/* --- PAGINATION UI --- */}
                              {!loading && totalPages > 1 && (
                                   <div className="pagination-wrapper">
                                        <button
                                             className="p-nav"
                                             disabled={currentPage === 1}
                                             onClick={() => { setCurrentPage(currentPage - 1); window.scrollTo(0, 0); }}
                                        >
                                             PREV
                                        </button>

                                        <div className="p-numbers">
                                             {getPageNumbers().map((num, idx) => (
                                                  <button
                                                       key={idx}
                                                       className={`p-btn ${currentPage === num ? "active" : ""} ${num === "..." ? "dots" : ""}`}
                                                       onClick={() => {
                                                            if (typeof num === 'number') {
                                                                 setCurrentPage(num);
                                                                 window.scrollTo(0, 0);
                                                            }
                                                       }}
                                                  >
                                                       {num}
                                                  </button>
                                             ))}
                                        </div>

                                        <button
                                             className="p-nav"
                                             disabled={currentPage === totalPages}
                                             onClick={() => { setCurrentPage(currentPage + 1); window.scrollTo(0, 0); }}
                                        >
                                             NEXT
                                        </button>
                                   </div>
                              )}
                         </main>
                    </div>

                       <section className='seo-content mt-5 pb-5'>
                         <div className='__container'>
                              <h1>Spicy AI Prompt Library (18+) – Bold Creative AI Image Prompts</h1>
                              <p className='mt-5 mb-5'> Explore the spicy AI prompt library on HeyPrompt featuring bold and creative prompts for AI image generation and artistic concepts.</p>
                              <code className='opacity-0 invisible'>spicy ai prompts, 18+ ai prompts, bold ai prompts, creative ai image prompts, artistic ai prompts, ai image prompt ideas</code>
                         </div>
                    </section>
               </div>

                    <AdultWarningModal />
            
          </>

     );
}